import type { GlobalFilter, GlobalFilterPayload, GlobalFilterId } from 'types/globalFilters';

import api from 'helpers/api';

export const fetchGlobalFilters = () => api.get<GlobalFilter[]>('/global-filters');
export const createGlobalFilter = (payload: GlobalFilterPayload) => api.post('/global-filters', payload);
export const updateGlobalFilter = (id: GlobalFilterId, payload: GlobalFilterPayload) => api.patch(`/global-filters/${id}`, payload);
export const deleteGlobalFilter = (id: GlobalFilterId) => api.delete<void>(`/global-filters/${id}`);
